import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { TradeInInformation } from '../../models/trade-in-api.model';
import { OSAffectedControlType } from '../../models/trade-in-enums';
import { finalize, take } from 'rxjs/operators';
import { NotificationService } from '@app/core/services/notification.service';
import { BehaviorSubject } from 'rxjs';
import { MatButtonToggleGroup, MatButtonToggle } from '@angular/material/button-toggle';
import { IceInfoIconComponent } from '@app/shared/components/atoms/ice-info-icon/ice-info-icon.component';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { EquipmentService } from '@app/sales/services/equipment.service';

type MobilePhoneOS = 'Ios' | 'Android';

@Component({
  selector: 'app-control-inquiry',
  templateUrl: './control-inquiry.component.html',
  styleUrl: './control-inquiry.component.scss',
  imports: [SpinnerComponent, IceInfoIconComponent, MatButtonToggleGroup, MatButtonToggle],
})
export class ControlInquiryComponent implements OnInit, OnChanges {
  private equipmentService = inject(EquipmentService);
  private notificationService = inject(NotificationService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  @Input({ required: true }) inquiredControl: OSAffectedControlType | string;

  activeOS$ = new BehaviorSubject<MobilePhoneOS>('Ios');

  isFetchingInformation = false;

  info: TradeInInformation;

  get isInquiredControlOSAffected() {
    return !!OSAffectedControlType[this.inquiredControl];
  }
  ngOnInit(): void {
    this.activeOS$.subscribe(activeOS => {
      this.fetchInformation(activeOS);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inquiredControl) this.fetchInformation(this.activeOS$.value);
  }

  private fetchInformation(activeOS?: MobilePhoneOS): void {
    const key = this.isInquiredControlOSAffected
      ? OSAffectedControlType[this.inquiredControl] + activeOS
      : (this.inquiredControl as string);

    if (this.info?.informationKey !== key) {
      this.isFetchingInformation = true;

      this.equipmentService
        .getInformation(key)
        .pipe(
          take(1),
          finalize(() => {
            this.isFetchingInformation = false;
            this.changeDetectorRef.detectChanges();
          })
        )
        .subscribe(
          response => (this.info = response),
          _ => this.notificationService.error('Error fetching information')
        );
    }
  }
}
